import getSeasonPrefixFromPath from './getSeasonPrefixFromPath';

export default function (path) {
    return !!getSeasonPrefixFromPath(path);
}
